import React from "react";
import styles from "./ProcessingSkeleton.module.scss";

interface ProcessingSkeletonProps {
  text?: string;
}

export const ProcessingSkeleton: React.FC<ProcessingSkeletonProps> = ({ text }) => {
  return (
    <div className={styles.container}>
      <div className={styles.spinner} />
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
};
